import styled from 'styled-components'
import Typography from '~components/dumbs/Typography'
import DefaultTitle from '~components/dumbs/Title'
import { WrapperProps } from './interfaces'

export const Description = styled(Typography).attrs({ as: 'p' })`
  font-weight: ${({ theme }) => theme.font.weight.medium};
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  color: ${({ theme }) => theme.neutral.text.default};
  text-align: center;
  letter-spacing: -0.03em;
  margin-bottom: ${({ theme }) => theme.spacing.km8};
`

export const Title = styled(DefaultTitle)`
  margin-top: ${({ theme }) => theme.spacing.km14};
`

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%);

  width: 100%;
  max-width: 500px;
`
